import { useNavigate } from 'react-router';
import { HeaderCommon } from '../../../../components/header';
import { CalendarBackIcon } from '../../../../assets/images';
import Scrollbars from 'react-custom-scrollbars';
import { get } from 'lodash';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import {
  getDetailServicePlan,
  getDetailVNPServicePlan,
  searchVNPServicePlans,
} from '../../../../services/service-plan';
import { PATH_PAGE, QUERY_KEY, SUPPLIER, VNP_PACKTYPE_TYPE } from '../../../../constant';
import { useContext, useEffect, useMemo, useState } from 'react';
import { ButtonGradient } from '../../../../components/common/button/ButtonGradient';
import { ButtonCustom } from '../../../../components/common/ButtonCustom';
import { getIconCategory } from '../../../../utils/getIconCategory';
import { ConfirmPackagePopup } from './ConfirmPackagePopup';
import { SpinCustom } from '../../../../components/common/SpinCustom';
import toast from 'react-hot-toast';
import useCheckDeviceMobi from 'hooks/useCheckDeviceMobi';
import { getIconSupplier } from 'utils/getIconSupplier';
import { getTypePackage } from 'utils/utils';
import AuthContext from 'context/AuthProvider';
import { AccountAuthen } from 'components/common/AccountAuthen';
import configs from 'configs/config';
import AppDownloadNotice from 'components/common/AppDownloadNotice';

export interface VnpDetail {
  id: number;
  packCode: string;
  packId: string;
  packName: string;
  status: number;
  amount: 0;
  type: number;
  packType: number;
  unit: string;
  numExpired: number;
  packDetail: string;
  groupDescription: string;
  packTypeDescription: string;
  hhOsp: number;
  shareValue: 0;
  packInfo?: string;
}

export const InfoPackage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const packType = location?.search?.split('packType=')[1];
  const isVNP = packType === SUPPLIER.VINAPHONE.toString();

  const { userLogin } = useContext(AuthContext);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [isShowNotification, setIsShowNotification] = useState<boolean>(false);
  const [vnpDetail, setVnpDetail] = useState<VnpDetail | undefined>();

  const isMobile = useCheckDeviceMobi();
  const { data, isLoading, remove } = useQuery(QUERY_KEY.PACKAGE_DETAIL, () => getDetailServicePlan(id), {
    enabled: !!id && packType !== SUPPLIER.VINAPHONE.toString(),
  });

  const mutationVNPSearchPackage = useMutation((param: any) => searchVNPServicePlans(param), {
    onSuccess: (response) => {
      console.log('response', response);
      if (response?.data?.data) {
        const res = response?.data?.data?.items.filter((item: VnpDetail) => item.packName === id);
        if (res[0]) {
          setVnpDetail(res[0]);
        }
        return;
      }
    },
    onError: (error) => {
      toast.error('Đã có lỗi xảy ra');
    },
  });
  const infoData = useMemo(() => {
    return get(data, 'data.data.data.items[0]', {});
  }, [data]);

  useEffect(() => {
    if (id && isVNP) {
      mutationVNPSearchPackage.mutate({
        dataPack: 0,
        fromAmount: '',
        hotPackage: 2,
        numExpiredChoice: '',
        packCode: '',
        packTypeChoice: [],
        page: 1,
        searchString: 'b129',
        sizeOfPage: 15,
        supplier: [0],
        toAmount: 3000000,
        traSau: 0,
        traTruoc: 0,
        typeSearch: 1,
      });
    }
    return () => remove();
  }, [id, isVNP]);

  return (
    <div className={'h-full w-full rounded-[20px] bg-[#F8F8F8] p-6 !pr-0'}>
      <HeaderCommon
        children={
          <div className={'flex flex-row items-center space-x-2'}>
            <span className={'mr-[8px] cursor-pointer'} onClick={() => navigate(-1)}>
              <img className="h-[18px] w-[18px]" src={CalendarBackIcon} alt="Logo" />
            </span>
            <span className={'text-[22px] font-extrabold text-[#404040]'}>Thông tin sản phẩm</span>
          </div>
        }
      />
      <div className={'relative mt-10 h-[calc(100%-90px)] w-full md:mt-0'}>
        {isLoading || mutationVNPSearchPackage.isLoading ? (
          <SpinCustom />
        ) : (
          <>
            {isMobile ? (
              <div className={'mr-7'}>
                <div
                  className={
                    'mb-2 flex cursor-pointer flex-row space-x-2 text-[12px] font-medium leading-[16px] text-[#71717A]' +
                    ' md:hidden'
                  }
                >
                  <NavLink to={PATH_PAGE.DASHBOARD}>Trang chủ</NavLink>
                  <span>|</span>
                  <span>Sản phẩm</span>
                  <span>|</span>
                  <span>Gói cước</span>
                </div>
                <div className="mb-4 flex flex-row items-center space-x-2">
                  <div onClick={() => navigate(-1)}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.54637 8.40283L9.33137 13.1888C9.52498 13.3824 9.78757 13.4912 10.0614 13.4912C10.3352 13.4912 10.5978 13.3824 10.7914 13.1888C10.985 12.9952 11.0938 12.7326 11.0938 12.4588C11.0938 12.185 10.985 11.9224 10.7914 11.7288L6.72637 7.66583L10.7914 3.60384C10.9848 3.41023 11.0935 3.14769 11.0934 2.87398C11.0934 2.73845 11.0666 2.60426 11.0147 2.47907C10.9628 2.35388 10.8867 2.24014 10.7909 2.14434C10.695 2.04854 10.5812 1.97256 10.456 1.92074C10.3308 1.86891 10.1965 1.84227 10.061 1.84231C9.78731 1.84241 9.52485 1.95123 9.33137 2.14484L4.54637 6.92983C4.35115 7.12522 4.24148 7.39013 4.24148 7.66633C4.24148 7.94254 4.35115 8.20745 4.54637 8.40283Z"
                        fill="#6A6A6A"
                      />
                    </svg>
                  </div>
                  <span className="text-lg font-bold text-baseColor">Thông tin sản phẩm</span>
                </div>
                <div
                  className={
                    'flex min-h-[116px] w-full flex-col justify-between rounded-t-[16px] rounded-bl-[16px] bg-white' +
                    ' border border-[#E5E5E5]/60 px-4 py-3 shadow-base'
                  }
                >
                  <div className={'grid w-full grid-cols-5 '}>
                    <div className={'col-span-3 flex flex-row items-center justify-between space-x-1.5'}>
                      <div className={'min-h-[58px] min-w-[58px]'}>
                        {getIconSupplier(isVNP ? 'Vinaphone' : infoData.supplier)}
                      </div>
                      <div className={'flex w-full flex-col'}>
                        <span className={'text-lg font-bold text-[#404040]'}>
                          {infoData.pckCode || vnpDetail?.packName}
                        </span>
                        <span className={'text-sm font-normal text-[#818181]'}>
                          {packType !== SUPPLIER.VINAPHONE.toString()
                            ? infoData.typeStr
                            : VNP_PACKTYPE_TYPE.find((subItem: any) => subItem.value === vnpDetail?.packType)?.label ||
                              '-'}
                        </span>
                        <span className={'text-sm font-normal text-[#818181]'}>{infoData.packDetail}</span>
                      </div>
                    </div>
                    <div className={'col-span-2 flex w-full flex-col items-end justify-center'}>
                      <div className={'flex flex-row items-center space-x-0.5 text-base font-bold text-[#F15836]'}>
                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.87891 2.89258C7.20831 2.89495 6.56585 3.1624 6.09166 3.63658C5.61747 4.11077 5.35003 4.75323 5.34766 5.42383C5.34766 5.87383 5.47534 6.29177 5.68178 6.65458C4.66872 7.24745 3.87559 8.08895 3.44922 9.08008H3.37891C3.34174 9.08092 3.30479 9.07423 3.27028 9.06039C3.23578 9.04656 3.20444 9.02587 3.17815 8.99959C3.15186 8.9733 3.13118 8.94196 3.11734 8.90745C3.10351 8.87295 3.09681 8.83599 3.09766 8.79883C3.09766 8.69983 3.14828 8.62108 3.22084 8.57045L2.57003 7.65639C2.38573 7.78455 2.23515 7.95537 2.13114 8.1543C2.02712 8.35322 1.97275 8.57435 1.97266 8.79883C1.97266 9.4907 2.48903 10.0577 3.15053 10.1702C3.12184 10.3671 3.09766 10.5634 3.09766 10.7676C3.09766 12.1693 3.84241 13.3843 4.92578 14.2832C4.78966 14.8457 4.85772 15.4453 5.29478 15.883C5.61746 16.2029 6.05344 16.3823 6.50781 16.3823C6.96219 16.3823 7.39817 16.2029 7.72084 15.883L7.93178 15.672C8.37109 15.753 8.81266 15.8301 9.28516 15.8301C9.75766 15.8301 10.1992 15.753 10.6385 15.672L10.8495 15.883C11.1721 16.2029 11.6081 16.3823 12.0625 16.3823C12.5169 16.3823 12.9529 16.2029 13.2755 15.883C13.7036 15.4543 13.7677 14.8721 13.6445 14.3181C14.0956 13.9517 14.4818 13.5121 14.787 13.0176H16.0352V8.51758H14.7521C14.5479 8.18604 14.3059 7.87931 14.031 7.60352L14.3477 5.86314V5.14258H13.7852C13.7852 5.14258 12.434 5.16508 11.2888 6.02177C10.9881 5.93502 10.683 5.86442 10.3747 5.81027C10.3972 5.68539 10.4102 5.55545 10.4102 5.42383C10.4102 4.03277 9.26997 2.89258 7.87891 2.89258ZM7.87891 4.01758C8.66078 4.01758 9.28516 4.64195 9.28516 5.42383C9.28516 5.52058 9.26772 5.61283 9.24972 5.70508C8.34241 5.70958 7.48572 5.88508 6.70159 6.17983C6.55224 5.956 6.47257 5.69292 6.47266 5.42383C6.47266 4.64195 7.09703 4.01758 7.87891 4.01758ZM13.082 6.37333C13.091 6.37108 13.091 6.37502 13.0995 6.37333L12.8885 7.65583L12.8362 7.95508L13.082 8.16602C13.4576 8.49129 13.7678 8.88512 13.9961 9.32645L14.1542 9.64258H14.9102V11.8926H14.1542L13.9961 12.2093C13.7216 12.7515 13.2885 13.2285 12.7305 13.6324L12.326 13.9316L12.5724 14.389C12.7063 14.6151 12.6821 14.8941 12.4841 15.0921C12.4307 15.1477 12.3666 15.192 12.2956 15.2223C12.2247 15.2526 12.1484 15.2682 12.0712 15.2682C11.9941 15.2682 11.9177 15.2526 11.8468 15.2223C11.7758 15.192 11.7117 15.1477 11.6583 15.0921L11.2539 14.6871L11.0255 14.4767L10.7263 14.547C10.2695 14.6522 9.78409 14.7051 9.28516 14.7051C8.80018 14.7068 8.31655 14.6538 7.84347 14.547L7.54534 14.4767L7.31641 14.6876L6.91197 15.0915C6.85857 15.1473 6.79443 15.1916 6.72343 15.222C6.65242 15.2523 6.57602 15.2679 6.49881 15.2679C6.42161 15.2679 6.3452 15.2523 6.2742 15.222C6.20319 15.1916 6.13906 15.1473 6.08566 15.0915C5.99308 15.0019 5.93391 14.8833 5.91795 14.7554C5.90199 14.6275 5.9302 14.498 5.99791 14.3884L6.24428 13.9316L5.83984 13.633C4.82228 12.8938 4.22266 11.8858 4.22266 10.7676C4.22266 8.6627 6.42203 6.83008 9.28516 6.83008C9.97703 6.83008 10.6363 6.93358 11.2365 7.12877L11.5352 7.23452L11.7815 7.02358C12.1832 6.66527 12.6798 6.47233 13.082 6.37333ZM12.6602 9.64258C12.3508 9.64258 12.0977 9.8957 12.0977 10.2051C12.0977 10.5145 12.3508 10.7676 12.6602 10.7676C12.9695 10.7676 13.2227 10.5145 13.2227 10.2051C13.2227 9.8957 12.9695 9.64258 12.6602 9.64258Z"
                            fill="#F15836"
                          />
                        </svg>
                        {`${
                          infoData.shareValue
                            ? (+infoData.shareValue).toLocaleString('vi')
                            : vnpDetail?.shareValue
                            ? (+vnpDetail.shareValue).toLocaleString('vi')
                            : 0
                        } VNĐ`}
                      </div>
                      <div className={'flex flex-row items-center space-x-2 text-sm font-normal text-[#818181]'}>
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M3.55859 3.51758H3.56234M3.55859 2.01758H5.43359C5.62559 2.01758 5.81759 2.0907 5.96384 2.23733L8.58884 4.86233C8.72945 5.00297 8.80843 5.1937 8.80843 5.39258C8.80843 5.59145 8.72945 5.78218 8.58884 5.92283L5.96384 8.54783C5.8232 8.68843 5.63247 8.76742 5.43359 8.76742C5.23472 8.76742 5.04399 8.68843 4.90334 8.54783L2.27834 5.92283C2.2086 5.85327 2.15328 5.77063 2.11556 5.67963C2.07785 5.58863 2.05849 5.49108 2.05859 5.39258V3.51758C2.05859 3.11975 2.21663 2.73822 2.49793 2.45692C2.77924 2.17561 3.16077 2.01758 3.55859 2.01758Z"
                            stroke="#818181"
                            strokeWidth="0.75"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        {isVNP
                          ? vnpDetail?.amount.toLocaleString('vi')
                          : get(infoData, 'amount', 0).toLocaleString('vi')}
                      </div>
                    </div>
                  </div>
                  <div className={'grid grid-cols-2 gap-2 border-t border-[#EFEFEF] pt-2'}>
                    <ButtonGradient
                      className={'h-[32px] w-full !rounded-t-[8px] !rounded-bl-[8px]'}
                      background={'bg-white !rounded-t-[6px] !rounded-bl-[6px]'}
                      onClick={() => {
                        if (userLogin?.statusVerify !== 1) {
                          setIsShowNotification(true);
                          return;
                        }
                        if (isVNP) {
                          navigator?.clipboard?.writeText(configs.API_DOMAIN + `/product/goi-cuoc-uu-dai/${encodeURIComponent(id || "")}?packType=vinaphone`);
                        } else {
                          navigator?.clipboard?.writeText(infoData.link);
                        }
                        toast.success('Sao chép link thành công!');
                        // setIsOpenConfirm(true);
                      }}
                    >
                      <span className={'text-sm font-bold leading-[18px] text-[#F15836]'}>Lấy link</span>
                    </ButtonGradient>
                    <button
                      className={
                        'h-[32px] w-full rounded-t-[8px] rounded-bl-[8px] bg-[#F15836] text-[12px] font-bold text-white' +
                        ' md:hidden'
                      }
                      onClick={() => setIsOpenConfirm(true)}
                    >
                      Đăng ký
                    </button>
                  </div>
                </div>
                <div className={'mt-4 grid h-full w-full grid-cols-1 gap-2'}>
                  <span className={'w-full text-base font-bold text-[#404040]'}>Thông tin gói cước</span>
                  <div className={'h-full rounded-[15px]'}>
                    <div
                      role={'list'}
                      className={
                        'rounded-[15px] border border-[#E5E7EB]/60 p-4 shadow-base odd:bg-white even:bg-[#F8F8F8]'
                      }
                    >
                      <div className={'grid grid-cols-2 space-x-2 rounded-t-[15px] rounded-bl-[15px] px-6 py-3'}>
                        <label className={'text-sm font-extrabold text-baseColor'}>Gói cước</label>
                        <label className={'text-end text-sm font-medium text-baseColor'}>
                          {isVNP ? vnpDetail?.packName : get(infoData, 'pckCode')}
                        </label>
                      </div>
                      <div
                        className={
                          'grid grid-cols-2 space-x-2 rounded-t-[15px] rounded-bl-[15px] bg-[#F8F8F8] px-6 py-3'
                        }
                      >
                        <label className={'text-sm font-extrabold text-baseColor'}>Giá gói</label>
                        <label className={'text-end text-sm font-medium text-baseColor'}>
                          {isVNP
                            ? vnpDetail?.amount.toLocaleString('vi')
                            : get(infoData, 'amount', 0).toLocaleString('vi')}
                        </label>
                      </div>
                      <div className={'grid grid-cols-2 space-x-2 rounded-t-[15px] rounded-bl-[15px] px-6 py-3'}>
                        <label className={'text-sm font-extrabold text-baseColor'}>Chu kỳ</label>
                        <label className={'text-end text-sm font-medium text-baseColor'}>
                          {isVNP ? vnpDetail?.numExpired : get(infoData, 'numExpired', '-')} ngày
                        </label>
                      </div>
                      <div
                        className={
                          'grid grid-cols-2 space-x-2 rounded-t-[15px] rounded-bl-[15px] bg-[#F8F8F8] px-6 py-3'
                        }
                      >
                        <label className={'text-sm font-extrabold text-baseColor'}>Nhà mạng</label>
                        <label className={'text-end text-sm font-medium text-baseColor'}>
                          {isVNP ? 'VinaPhone' : get(infoData, 'supplier', '-')}
                        </label>
                      </div>
                      <div className={'grid grid-cols-2 space-x-2 rounded-t-[15px] rounded-bl-[15px] px-6 py-3'}>
                        <label className={'text-sm font-extrabold text-baseColor'}>Hoa hồng</label>
                        <label className={'text-end text-sm font-medium text-baseColor'}>
                          {isVNP
                            ? vnpDetail?.shareValue.toLocaleString('vi')
                            : get(infoData, 'shareValue', 0)?.toLocaleString('vi') || 0}
                          đ
                        </label>
                      </div>
                      <div
                        className={
                          'grid grid-cols-2 space-x-2 rounded-t-[15px] rounded-bl-[15px] bg-[#F8F8F8] px-6 py-3'
                        }
                      >
                        <label className={'text-sm font-extrabold text-baseColor'}>Ưu đãi</label>
                        <label className={'text-end text-sm font-medium text-baseColor'}>
                          {isVNP ? vnpDetail?.packDetail : get(infoData, 'packDetail', '-')}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={'mt-4 rounded-t-[15px] bg-white p-6'}>
                  {isVNP ? (
                    vnpDetail?.packInfo ? (
                      <span
                        className={'text-sm font-medium text-baseColor'}
                        dangerouslySetInnerHTML={{ __html: get(vnpDetail, 'packInfo') || '' }}
                      />
                    ) : (
                      <span className={'text-base font-medium text-baseColor'}>Không có dữ liệu</span>
                    )
                  ) : (
                    <span
                      className={'text-sm font-medium text-baseColor'}
                      dangerouslySetInnerHTML={{ __html: get(infoData, 'note') }}
                    />
                  )}
                </div>
              </div>
            ) : (
              <Scrollbars className={'h-full w-full'}>
                <div className={'mr-7'}>
                  <div
                    className={
                      'flex flex-row justify-between rounded-t-[15px] rounded-bl-[15px] bg-white px-6 py-3' +
                      ' items-center'
                    }
                  >
                    <div className={'flex flex-row items-center'}>
                      {getIconCategory('GOICUOC')}
                      <span className={'ml-2 text-base font-bold text-baseColor'}>
                        Gói cước {isVNP ? vnpDetail?.packName : get(infoData, 'pckCode')}
                      </span>
                    </div>
                    <div className={'flex flex-col items-end justify-center space-y-1 md:flex-row md:space-x-2.5'}>
                      <ButtonGradient
                        className={'h-[30px] w-[100px]'}
                        background={'bg-white'}
                        onClick={() => {
                          if (userLogin?.statusVerify !== 1) {
                            setIsShowNotification(true);
                            return;
                          }
                          if (isVNP) {
                            navigator?.clipboard?.writeText(configs.API_DOMAIN + `/product/goi-cuoc-uu-dai/${encodeURIComponent(id || '')}?packType=vinaphone`);
                          } else {
                            navigator?.clipboard?.writeText(infoData.link);
                          }
                          toast.success('Sao chép link thành công!');
                          // setIsOpenConfirm(true);
                        }}
                      >
                        <span className={'text-sm font-semibold text-[#F15836]'}>Lấy link</span>
                      </ButtonGradient>
                      <ButtonCustom
                        label={'Đăng ký'}
                        background={'bg-[#F15836]'}
                        onClick={() => setIsOpenConfirm(true)}
                        className={'h-[30px] w-[100px] !rounded-l-[10px] !text-sm !font-semibold'}
                      />
                    </div>
                  </div>
                  <div className={'mt-6 grid h-fit w-full grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3'}>
                    <div
                      className={
                        'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white p-6'
                      }
                    >
                      <div className={'flex flex-row items-center'}>
                        <svg
                          className={'-mt-1'}
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="6.14253" cy="6.74995" r="6.04878" fill="#F15836" />
                        </svg>
                        <span className={'ml-1 text-base font-bold text-baseColor'}>Gói cước123</span>
                      </div>
                      <span className={'text-base font-medium text-baseColor'}>
                        {isVNP ? vnpDetail?.packName : get(infoData, 'pckCode')}
                      </span>
                    </div>
                    <div
                      className={
                        'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white p-6'
                      }
                    >
                      <div className={'flex flex-row items-center'}>
                        <svg
                          className={'-mt-1'}
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="6.14253" cy="6.74995" r="6.04878" fill="#F15836" />
                        </svg>
                        <span className={'ml-1 text-base font-bold text-baseColor'}>Giá gói</span>
                      </div>
                      <span className={'text-base font-medium text-baseColor'}>
                        {isVNP
                          ? vnpDetail?.amount.toLocaleString('vi')
                          : get(infoData, 'amount', 0).toLocaleString('vi')}
                      </span>
                    </div>
                    <div
                      className={
                        'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white p-6'
                      }
                    >
                      <div className={'flex flex-row items-center'}>
                        <svg
                          className={'-mt-1'}
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="6.14253" cy="6.74995" r="6.04878" fill="#F15836" />
                        </svg>
                        <span className={'ml-1 text-base font-bold text-baseColor'}>Chu kỳ</span>
                      </div>
                      <span className={'text-base font-medium text-baseColor'}>
                        {isVNP ? vnpDetail?.numExpired : get(infoData, 'numExpired', '-')} ngày
                      </span>
                    </div>
                    <div
                      className={
                        'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white p-6'
                      }
                    >
                      <div className={'flex flex-row items-center'}>
                        <svg
                          className={'-mt-1'}
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="6.14253" cy="6.74995" r="6.04878" fill="#F15836" />
                        </svg>
                        <span className={'ml-1 text-base font-bold text-baseColor'}>Nhà mạng</span>
                      </div>
                      <span className={'text-base font-medium text-baseColor'}>
                        {isVNP ? 'VinaPhone' : get(infoData, 'supplier', '-')}
                      </span>
                    </div>
                    <div
                      className={
                        'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white p-6'
                      }
                    >
                      <div className={'flex flex-row items-center'}>
                        <svg
                          className={'-mt-1'}
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="6.14253" cy="6.74995" r="6.04878" fill="#F15836" />
                        </svg>
                        <span className={'ml-1 text-base font-bold text-baseColor'}>Hoa hồng</span>
                      </div>
                      <span className={'text-base font-medium text-baseColor'}>
                        {isVNP
                          ? vnpDetail?.shareValue.toLocaleString('vi')
                          : get(infoData, 'shareValue', 0)?.toLocaleString('vi') || 0}
                        đ
                      </span>
                    </div>
                    <div
                      className={
                        'flex flex-row items-center justify-between space-x-4 rounded-t-[15px] rounded-bl-[15px] bg-white p-6'
                      }
                    >
                      <div className={'flex flex-row items-center'}>
                        <svg
                          className={'-mt-1 min-h-[13px] min-w-[13px]'}
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="6.14253" cy="6.74995" r="6.04878" fill="#F15836" />
                        </svg>
                        <span className={'ml-1 whitespace-nowrap text-base font-bold text-baseColor'}>Ưu đãi</span>
                      </div>
                      <span className={'text-justify text-base font-medium text-baseColor'}>
                        {isVNP ? vnpDetail?.packDetail : get(infoData, 'packDetail', '-')}
                      </span>
                    </div>
                  </div>
                  <div className={'mt-4 rounded-t-[15px] bg-white p-6'}>
                    {isVNP ? (
                      vnpDetail?.packInfo ? (
                        <span
                          className={'text-base font-medium text-baseColor'}
                          dangerouslySetInnerHTML={{ __html: get(vnpDetail, 'packInfo') || '' }}
                        />
                      ) : (
                        <span className={'text-base font-medium text-baseColor'}>Không có dữ liệu</span>
                      )
                    ) : (
                      <span
                        className={'text-base font-medium text-baseColor'}
                        dangerouslySetInnerHTML={{ __html: get(infoData, 'note') }}
                      />
                    )}
                  </div>
                </div>
              </Scrollbars>
            )}
          </>
        )}
      </div>
      {isOpenConfirm && (
        // <ConfirmPackagePopup
        //   packageName={isVNP ? vnpDetail?.packName : infoData.pckCode}
        //   onClose={() => setIsOpenConfirm(false)}
        //   item={{ ...isVNP ? { ...vnpDetail, supplier: 'Vinaphone' } : { ...infoData, supplier: 'Mobifone' } }} />
        <AppDownloadNotice setShowDialog={setIsOpenConfirm} showDialog={isOpenConfirm} />
      )}
      {isShowNotification && <AccountAuthen setIsShowNotification={setIsShowNotification} />}
    </div>
  );
};
